import {Button} from '@/components/ui/button';
import {ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, RefreshCw, RouteOffIcon,} from 'lucide-react';
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from '@/components/ui/select.tsx';
import {cn} from '@/lib/utils.ts';
import { UseAppTableReturn } from '@/components/table/use-app-table.ts';

type Props = {
  at: UseAppTableReturn<any>;
};

export function AppPagination({at}: Props) {
  const totalItems = at.table.getRowCount();
  return (
    <div
      className={cn('flex flex-col md:flex-row mt-2 mb-3 justify-between gap-3 items-center', at.paginationClassName)}>
      <div className="flex items-center gap-2">
        {at.pagination?.form && (
          <Button
            className="w-4 h-4"
            variant="ghost"
            size="icon"
            onClick={at.pagination.reset}
          >
            <RouteOffIcon size={15}/>
          </Button>
        )}
        {at.refetch && (
          <Button
            className="w-4 h-4"
            variant="ghost"
            size="icon"
            onClick={at.refetch}
          >
            <RefreshCw size={15}/>
          </Button>
        )}
        {totalItems > 0 ? (
          <span>
            Page {Number(at.table.getState().pagination.pageIndex) + 1} of{' '}
            {at.table.getPageCount()}, Total Items: {totalItems}
          </span>
        ) : (
          <span>No items</span>
        )}
      </div>
      <div className="flex">
        {at.pageSizeOptions && (
          <Select
            defaultValue={String(at.table.getState().pagination.pageSize)}
            onValueChange={value => {
              at.table.setPageSize(Number(value));
            }}
          >
            <SelectTrigger className="w-18 mr-2">
              <SelectValue/>
            </SelectTrigger>
            <SelectContent>
              {at.pageSizeOptions.map((size) => (
                <SelectItem key={size} value={String(size)}>
                  {size}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
        <Button
          size="icon"
          variant="outline"
          onClick={() => at.table.firstPage()}
          disabled={!at.table.getCanPreviousPage()}
        >
          <ChevronsLeft/>
        </Button>
        <Button
          size="icon"
          variant="outline"
          onClick={() => at.table.previousPage()}
          disabled={!at.table.getCanPreviousPage()}
        >
          <ChevronLeft/>
        </Button>
        <Button
          size="icon"
          variant="outline"
          onClick={() => at.table.nextPage()}
          disabled={!at.table.getCanNextPage()}
        >
          <ChevronRight/>
        </Button>
        <Button
          size="icon"
          variant="outline"
          onClick={() => at.table.lastPage()}
          disabled={!at.table.getCanNextPage()}
        >
          <ChevronsRight/>
        </Button>
      </div>
    </div>
  );
}
